import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild, TemplateRef,Input } from '@angular/core';
import { ModalDirective, BsModalRef, BsModalService, } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { DLScannerService } from 'src/app/services/dlscanner.service';
import { DatePipe} from '@angular/common';

@Component({
    selector: 'app-dlscanner',
    templateUrl: './dlscanner.component.html',
    styleUrls: ['./dlscanner.component.scss'],
    standalone: false
})
export class DlscannerComponent implements OnInit, OnDestroy {
  constructor(private toastr: ToastrService,
    private dlScannerService: DLScannerService,
    private modalService: BsModalService) { }

  @ViewChild('scanningdataModal', { static: false }) scanneddataModal: ModalDirective;
  @Output() responseDLData: EventEmitter<any> = new EventEmitter<any>();
  @Output() actionTriggered : EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('templateViewDL', { static: true }) templateDLPreview: TemplateRef<any>;
  @ViewChild('templateScanError', { static: true }) templateScanError: TemplateRef<any>;
  @ViewChild('templateDeviceConnected', { static: true }) templateDeviceConnected: TemplateRef<any>;

  modelDLPreview: BsModalRef;
  dlReaderInfoModel: BsModalRef;
  dlScanValidation: BsModalRef;
  cardUnknown;
  fullName;
  lastName;
  firstName;
  middleName;
  faceimage;
  fullimage;
  state;
  country;
  postalCode;
  city;
  imageurl;
  sendDlDetailsObj;
  dob;
  doi;
  doe;
  obj;
  toasterConfig = {
    closeButton: true,
    timeOut: 10000,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  sub: any;
  dlImageUrl: any = '';
  fullDlDetails;
  dlSessionGuid;
  socket: WebSocket;
  public loaderIcon: Promise<boolean>;
  dlScannerMessage = "";
  receivedData;
  isDLPreviewEnabled = false;
  deviceReady = false;
  dapServiceStarted = false;
  scanBtnClicked = false;
  dlScannerLicenseEnabled;
  dlScannerEnableForFacility;
  deviceName;
  WebAPIURL;
  webSocketURL;
  @Input() FacilityId: string;
  ngOnInit() {    
    this.GetDLScannerSettings(this.FacilityId);       
  }

  triggerAction(loaderAction,Scanloader) {
    var ObjloaderAction={
      loaderAction:loaderAction,
      dlScanloaderRequest:Scanloader
    }
   this.actionTriggered.emit(ObjloaderAction);
  }

  StartDlScan() {
    this.socket = new WebSocket(this.webSocketURL);    
    this.triggerAction(true,false);
    this.dlSessionGuid = this.generateRandomGuid();    
    this.dlScannerService.startScanSession(this.WebAPIURL,this.dlSessionGuid).subscribe((res: any) => {
      console.log(this.dlSessionGuid);  
    }, err => {      
      switch (err.status) {
        case 0:
          this.toastr.info('DL Scanner is disabled. Please contact administrator', 'Info', this.toasterConfig);
          break
        case 405:
          this.socket = new WebSocket(this.webSocketURL);
          this.StartDlScan();
          break;
      }
    });
    this.triggerAction(false,false);
  }

  GetDLScannerSettings(facilityId) {    
    this.triggerAction(true,false);
    this.dlScannerService.getDLScannerSettings(facilityId).subscribe((response: any) => {
      if (response) {
        this.dlScannerLicenseEnabled = response.DLScannerLicenseEnabled;
        this.dlScannerEnableForFacility = response.DLScannerEnableForFacility;
        this.deviceName = response.DeviceName;
        this.WebAPIURL = response.WebAPIURL;   
        this.webSocketURL = response.WebSocketURL;             
        this.StartDlScan();   
        this.connectWebSocket();
      }
      this.triggerAction(false,false);
    }, err => {
      this.triggerAction(false, false);
    });
  }

  connectWebSocket() {
   // this.socket = new WebSocket(this.serverUrl);    
    this.socket.addEventListener('message', (event) => {
      const data = JSON.parse(event.data);
      this.handleData(data);
    });
  }

  disconnectWebSocket() {
    if (this.socket) {
      this.socket.close();
    }
  }

  getEventType(data, targetKey)
  {
    for (const key in data) {
      if (key === targetKey) {
        return data[key];
      } else if (typeof data[key] === 'object') {
        const result = this.getEventType(data[key], targetKey);
        if (result !== undefined) {
          return result;
        }
      }
    }
    return undefined;
  }

  getReaderDetails(deviceInfo) {
    console.log("deviceInfo");
    if (!deviceInfo) {
      this.toastr.info('DL Scanner device not detected', 'Info', this.toasterConfig);
    }
    else if (!deviceInfo.Calibrated || deviceInfo.DocumentTriggerMode == 0 || deviceInfo.ReaderStatus != 1 ||!deviceInfo.DocumentDetectEnabled) {
      this.toastr.info('Issue with setting up the DL Scanner device', 'Info', this.toasterConfig);
    }
  }

  handleData(data: any) {
    // Process and store WebSocket data in the component
   this.receivedData = data;
    const eventype = this.getEventType(data, "EventType")
    switch (eventype) {
      case 1:
        const platFormStatus = this.receivedData.NewPlatformStatus;
        switch (platFormStatus) {
          case 1:
            this.triggerAction(true, false);
            this.dlScannerService.startDAPService(this.WebAPIURL,this.dlSessionGuid).subscribe((response: any) => {
            });
            break;
          case 4:
            // this.loaderIcon = Promise.resolve(false);
            if (!this.isDLPreviewEnabled) {
              this.deviceReady = true;
              this.dlScannerService.getReaderInfo(this.WebAPIURL,this.dlSessionGuid,this.deviceName).subscribe((res: any) => {
                this.getReaderDetails(res);
              }, err => {
                console.log("error in getReaderInfo");
              });
            }
            this.triggerAction(false,false);
            break;
          case 5:
            console.log("DAP started transaction");
            this.triggerAction(true,true);
            break;
          default:
            break;
        }
        break;
      case 1024:
        if (this.isDLPreviewEnabled)
          this.modelDLPreview.hide()
        if (this.cardUnknown)
          this.dlScanValidation.hide();
         this.dlImageUrl = 'data:image/jpeg;base64,' + this.receivedData.DocumentEventArgs.Document.Images['Image-Array'].filter(item => item.DocumentImage.Name == "White" && item.DocumentImage.Side == "0")[0].DocumentImage.Bitmap['image byte array'];
          this.modelDLPreview = this.modalService.show(this.templateDLPreview, { class: 'modal-dialog modal-dialog-centered', backdrop: 'static', keyboard: false });
          this.fullDlDetails = this.receivedData.DocumentEventArgs;
          this.isDLPreviewEnabled = true;    
        break;
      case 524288:
        this.getReaderDetails(this.receivedData);
        break;
    }    
  }

  generateRandomGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.dlScannerService.closeScanSession(this.WebAPIURL,this.dlSessionGuid).subscribe((response: any) => {
    });
    this.disconnectWebSocket();
  }

  fillform() {
    if (this.fullDlDetails.Document.DocumentInfo.Name.toLowerCase() != "unknown") {
      var infoFields = this.fullDlDetails.Document.Fields;

      const dateFormatPattern = /^(\d{2}[-/]\d{2}[-/]\d{4})$/;
      const datepipe: DatePipe = new DatePipe('en');
       const FullName = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "First Name");
       const MiddleName = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Middle Name");
       const LastName = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Surname");
       const Address = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Address Line 1");
       const City = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Address City");
       const State = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Address State");
       const Country = this.fullDlDetails.Document.DocumentInfo.DocumentType.CountryCode;
       const PostalCode = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Address Postal Code");
       const DLNumber = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Document Number");
       const DOB = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Birth Date");
       const DOE = infoFields['Field-Array'].filter(item => item.DocumentField.DisplayName == "Expiration Date");
       const dateOfBirth = DOB.length > 0 ? datepipe.transform(DOB[0].DocumentField.Value, 'MM/dd/yyyy') : "";
       const dlExpiryDate = DOE.length > 0 ? datepipe.transform(DOE[0].DocumentField.Value, 'MM/dd/yyyy') : "";
       const faceImage = this.fullDlDetails.Document.Regions['Region-Array'].filter(item => item.DocumentRegion.Name == "Photo");
      
      // Check if the date is valid
      if (dateFormatPattern.test(dateOfBirth) && dateFormatPattern.test(dlExpiryDate)) {
        this.obj = {
          FullName: FullName.length > 0 ? FullName[0].DocumentField.Value : "",
          FirstName: FullName.length > 0 ? FullName[0].DocumentField.Value : "",
          MiddleName: MiddleName.length > 0 ? MiddleName[0].DocumentField.Value : "",
          LastName: LastName.length > 0 ? LastName[0].DocumentField.Value : "",
          Address: Address.length > 0 ? Address[0].DocumentField.Value : "",
          City: City.length > 0 ? City[0].DocumentField.Value : "",
          State: State.length > 0 ? State[0].DocumentField.Value.toUpperCase() : "",
          Country: Country,
          PostalCode: PostalCode.length > 0 ? PostalCode[0].DocumentField.Value : "",
          DLNumber: DLNumber.length > 0 ? DLNumber[0].DocumentField.Value : "",
          DOB: DOB.length > 0 ? DOB[0].DocumentField.Value : "",
          DOE: DOE.length > 0 ? DOE[0].DocumentField.Value : "",
          //DOI: this.doi,
          FaceImage: faceImage.length > 0 ? 'data:image/jpeg;base64,' + faceImage[0].DocumentRegion['Image-Bitmap'].Bitmap['image byte array'] : null,
        };
        this.cardUnknown=false;
        this.responseDLData.emit(this.obj);
        this.modelDLPreview.hide();
        this.isDLPreviewEnabled = false;
      }
      else {
        this.cardUnknown = true;
        this.dlScanValidation = this.modalService.show(this.templateScanError, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
        this.modelDLPreview.hide();
        this.isDLPreviewEnabled = false;
      }
    }
    else {
      this.cardUnknown = true;
      this.dlScanValidation = this.modalService.show(this.templateScanError, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
      this.modelDLPreview.hide();
      this.isDLPreviewEnabled = false;
    }
  }
}
